import { Routes, Route } from 'react-router-dom'
import FailuresPage from './pages/FailuresPage'
import AgentsPage from './pages/AgentsPage'
import RunsPage from './pages/RunsPage'
import RunDetailsPage from './pages/RunDetailsPage'
import SettingsPage from './pages/SettingsPage'
import FailureDetailPage from './pages/FailureDetailPage'
import AgentDetailPage from './pages/AgentDetailPage'
import ProcessingPage from './pages/ProcessingPage'
import ResourcesPage from './pages/ResourcesPage'
import ReportsPage from './pages/ReportsPage'
import ReportDetailPage from './pages/ReportDetailPage'
import MainPage from './pages/MainPage'
import AppContentFooter from './components/AppContentFooter'

function App() {
  return (
    <div data-testid="main-page">
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/failures" element={<FailuresPage />} />
        <Route path="/failures/:failureId" element={<FailureDetailPage />} />
        <Route path="/agents" element={<AgentsPage />} />
        <Route path="/agents/:agentId" element={<AgentDetailPage />} />
        <Route path="/runs" element={<RunsPage />} />
        <Route path="/runs/:runId" element={<RunDetailsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/reports/:reportId" element={<ReportDetailPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/processing" element={<ProcessingPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Routes>
      <AppContentFooter />
    </div>
  )
}

export default App
